import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import { changeOutsourceContractNeedClearApi} from '../services'
export default {
    data() {
        return {
            show: false,
            saveLoading: false,
            params: {
                id: null,
                need_clear: null,
            }
        }
    },
    computed: {
        fields_list() {
            return [{
                label: '合同是否需要清理',
                type: 'radio_buttons',
                key: 'need_clear',
                required: true,
                rules: [r => {
                    return !![false, true].includes(r) || '必选'
                }],
                // row:true,
               // row: true,
                cols: 6,
                items: [
                    {
                        value: true,
                        key: true,
                        label: '需要清理',
                    },
                    {
                        value: false,
                        key: false,
                        label: '不需要清理',
                    }
                ]
            }]
        }
    },
    methods: {
        edit(c) {
            this.params.id = c.id
            this.params.need_clear = null
            this.$refs.form && this.$refs.form.resetValidation()
            this.$nextTick(() => {
                this.show = true
            })
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.saveLoading = true
                changeOutsourceContractNeedClearApi(this.params).then(res => {
                    this.$Message.success('数据修改成功！')
                    this.show = false
                    this.$emit('success')
                }).finally(() => {
                    this.saveLoading = false
                })
            }
        }
    },
   render() {
    const _this = this
    return <VModal 
    dynamicHeight
    heightRate={0.2}
    v-model={this.show}
    title='提示'
    loading={this.saveLoading}
    width={500}
    ref="modal"
    // cancelText={_this.params.pigeonhole_flag === 1 ? '' : '取消'}
    // okText={_this.params.pigeonhole_flag === 1 ? '关闭' : '确定'}
    on={{
    ok: () => {
        _this.submit()
    }
    }}
>
    <div>
        <VForm 
            ref="form"
            v-model={_this.params}
            fields={_this.fields_list}
            >
        </VForm>
    </div>
</VModal>
   } 
}